var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ImpressionEventConverter } from '../eventConverters/ImpressionEventConverter';
import { InteractionEventConverter } from '../eventConverters/InteractionEventConverter';
import { UBIPageInstanceIdProvider, } from '../providers/PageInstanceIdProvider';
import { PageViewLogger } from './PageViewLogger';
import { StorageManager } from '../storage/StorageManager';
import { UBIPageUriProvider, } from '../providers/PageUriProvider';
import { UBIPageIdProvider } from '../providers/PageIdProvider';
var UBILogger = (function () {
    function UBILogger(options) {
        var _a, _b;
        this.eventSender = options.eventSender;
        this.disableAutoBackgroundMonitoring =
            (_a = options.disableAutoBackgroundMonitoring) !== null && _a !== void 0 ? _a : true;
        this.storageManager = new StorageManager({
            storageAdapter: options.storageAdapter,
            requiresPersistingState: options.requiresPersistingState
        });
        this.authenticationProvider = options.authenticationProvider;
        this.pageInstanceIdProvider = new UBIPageInstanceIdProvider({
            storageManager: this.storageManager
        });
        this.pageUriProvider = new UBIPageUriProvider({
            storageManager: this.storageManager
        });
        this.pageIdProvider = new UBIPageIdProvider({
            storageManager: this.storageManager
        });
        this.contextualProviders = options.contextualProviders;
        this.pageViewLogger = new PageViewLogger({
            eventSender: options.eventSender,
            pageInstanceIdProvider: this.pageInstanceIdProvider,
            pageUriProvider: this.pageUriProvider,
            pageIdProvider: this.pageIdProvider,
            disableAutoBackgroundMonitoring: this.disableAutoBackgroundMonitoring,
            storageManager: this.storageManager,
            authenticationProvider: this.authenticationProvider,
            flowIdProvider: (_b = this.contextualProviders) === null || _b === void 0 ? void 0 : _b.flowIdProvider
        });
    }
    UBILogger.prototype.registerEventListeners = function () {
        this.pageViewLogger.addEventListeners();
    };
    UBILogger.prototype.unregisterEventListeners = function () {
        this.pageViewLogger.removeEventListeners();
    };
    UBILogger.prototype.logInteraction = function (event) {
        var gabitoEvent = InteractionEventConverter.createGabitoEvent(event, this.authenticationProvider, __assign(__assign({}, this.contextualProviders), { pageInstanceIdProvider: this.pageInstanceIdProvider, pageUriProvider: this.pageUriProvider, pageIdProvider: this.pageIdProvider }));
        this.eventSender.send(gabitoEvent);
        return gabitoEvent.data.interaction_id || '';
    };
    UBILogger.prototype.logImpression = function (event) {
        var gabitoEvent = ImpressionEventConverter.createGabitoEvent(event, this.authenticationProvider, __assign(__assign({}, this.contextualProviders), { pageInstanceIdProvider: this.pageInstanceIdProvider, pageUriProvider: this.pageUriProvider, pageIdProvider: this.pageIdProvider }));
        this.eventSender.send(gabitoEvent);
        return gabitoEvent.data.impression_id || '';
    };
    UBILogger.prototype.logNavigationStart = function (navigationStartInfo) {
        this.pageViewLogger.startNavigation(navigationStartInfo);
    };
    UBILogger.prototype.logNavigationEnd = function (navigationEndInfo) {
        this.pageViewLogger.completeNavigation(navigationEndInfo);
    };
    UBILogger.prototype.logNavigation = function (navigationStartInfo, navigationEndInfo) {
        this.logNavigationStart(navigationStartInfo);
        this.logNavigationEnd(navigationEndInfo);
    };
    UBILogger.prototype.logClientLostFocus = function () {
        if (this.disableAutoBackgroundMonitoring) {
            this.pageViewLogger.logClientLostFocus();
        }
    };
    UBILogger.prototype.logClientGainedFocus = function () {
        if (this.disableAutoBackgroundMonitoring) {
            this.pageViewLogger.logClientGainedFocus();
        }
    };
    UBILogger.prototype.getPageInstanceId = function () {
        return this.pageInstanceIdProvider.getPageInstanceId();
    };
    return UBILogger;
}());
export { UBILogger };
//# sourceMappingURL=UBILogger.js.map